<template lang="html">
  <step
    :title="title"
    :icon="icon"
    :complete="complete"
    :step="step">
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs6 v-for="(bus, busIndex) in tripBuses" :key="busIndex">
          <material-card
            :title="types[bus.type]"
            text="Select rates to use. Displayed price is for that trip leg."
            dark
            hover
            color="busie">
            <v-layout row wrap justify-left class="mt-2 mb-2">
              <v-flex xs12 v-for="(stop, stopIndex) in stops" :key="stopIndex"v-if="stopIndex !== stops.length - 1">
                <v-layout row justify-left>
                  <span class="ml-2">
                    Leg {{ stopIndex + 1 }}: {{ friendlyLocation(stop.location) }} -> {{ friendlyLocation(stops[stopIndex + 1].location) }}
                  </span>
                </v-layout>
                <v-layout row justify-left>
                  <span class="ml-4">
                    {{ rates[busIndex] ? rates[busIndex][stopIndex].name : '' }}
                    - ${{pricing[busIndex] ? pricing[busIndex][stopIndex] : 0}}
                    <rate-select
                      :rates="selectableRates[busIndex]"
                      v-model="selectedRate"
                      @continue="confirmSelectedRate(busIndex, stopIndex)">
                      <template #activator=" { on } ">
                        <edit-btn v-on="on"/>
                      </template>
                    </rate-select>
                  </span>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row justify-left>
                  <span class="ml-2">
                    Flat Trip Rate - ${{ Math.max(...flatRates[busIndex]) }}
                    <info-icon
                      icon="mdi-information"
                      color="primary"
                      message="Automatically updated according to selected rates. This value is always the maximum with respect to these rates for this bus."/>
                  </span>
                </v-layout>
              </v-flex>
            </v-layout>
          </material-card>
        </v-flex>
        <v-flex xs12>
          <v-btn
            color="primary"
            :loading="!!loading"
            :disabled="!!loading"
            @click="submit">
            Submit Quote
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </step>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MaterialCard from '@/components/material/Card';
import EditButton from './EditButton';
import InfoIcon from './InfoIcon'
import label from '@/utils/label'
import Step from './Step'
import RateCard from './RateCard'
import StandardDialog from './StandardDialog'
import RateDialog from './RateDialog'
import RateSelect from './RateSelect'
export default {
  components: {
    'material-card': MaterialCard,
    'edit-btn': EditButton,
    'info-icon': InfoIcon,
    step: Step,
    'rate-card': RateCard,
    'standard-dialog': StandardDialog,
    'rate-dialog': RateDialog,
    'rate-select': RateSelect
  },
  props: {
    complete: {
      type: Boolean,
      default: false
    },
    step: {
      type: [Number, String],
      default: 4
    },
    trip: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      types: {
        'motorcoach': 'Motor Coach',
        'doubledecker': 'Double Decker',
        'minibus': 'Mini Bus',
        'executivecoach': 'Executive Coach',
        'partybus': 'Party Bus',
        'schoolbus': 'School Bus',
        'entertainercoach': 'Entertainer Coach',
        'trolley': 'Trolley',
        'van': 'Van'
      },
      rates: [],
      pricing: [],
      flatRates: [],
      selectedRate: null,
      title: 'Rate Confirmation',
      icon: 'mdi-currency-usd',
      loading: false,
      overnightTrip: false,
    }
  },
  computed: {
    tripBuses () {
      return this.trip.busTypes ? this.trip.busTypes.map(b => this.busTypeMap[b]) : []
    },
    stopDates () {
      return this.stops.filter(stop => !!stop.date).map(stop => stop.date)
    },
    defaultRates () {
      // i need an array of len #bus with nested array len #stops
      return this.tripBuses.map(
        b => this.stops.map(() => this.getDefaultRate(b))
      )
    },
    selectableRates () {
      return this.tripBuses.map(
        bt => this.ratesByBusTypeMap[bt.id].map(
          schema => ({ value: schema.id, text: schema.name })
        )
      )
    },
    ...mapGetters('vehicles', {
      busTypes: 'types',
      busTypeMap: 'typesMap',
      ratesByBusTypeMap: 'ratesByTypeMap'
    }),
    ...mapGetters('plan', [ 'stops', 'route', 'deadHeads' ]),
    ...mapGetters('dates', { dateById: 'byId' }),
    ...mapGetters('user', { userId: 'id' }),
    ...mapGetters('dispatch', { dispatchId: 'id' }),
    ...mapGetters('auth', ['token'])
  },
  mounted () {
    this.defaultRates.forEach((bus, index) => {
      this.rates.push(bus)
      this.pricing.push([])
      this.flatRates.push([])
      bus.forEach(leg => {
        this.pricing[index].push(0)
        this.flatRates[index].push(0)
      })
    });
    for (let i = 0; i < this.tripBuses.length; i++) {
      for (let j = 0; j < this.stops.length - 1; j++) {
        const rate = this.rates[i][j]
        this.loading = true;
        this.getPriceAndTripFlat(i, j).then(() => {
          this.loading = false;
        }).catch(e => {
          this.raiseError(e)
          this.loading = false
        })
      }
    }
    // this.pricing.forEach((bus, busIdx) => {
    //   bus.forEach((legPrice, legIdx, arr) => {
    //     let rate = this.rates[busIdx][legIdx]
    //     this.loading = true
    //     this.getPrice(rate, legIdx).then(res => {
    //       if (!res) {return}
    //       arr.splice(legIdx, 1, Math.ceil(res.data.price))
    //       this.loading = false
    //     }).catch(e => {
    //       this.raiseError(e)
    //       this.loading = false
    //     })
    //   })
    // })
  },
  methods: {
    async getPrice (rate, stopIdx) {
      const axios = require('axios')
      const headers = { Authorization: 'Bearer '+this.token }
      let resource;
      if (process.env.VUE_APP_STAGING) {
        resource = '/rateSchema';
      } else {
        resource = '/rate-schemas'
      }
      const path = `${resource}/price/`+rate.id
      const leg = this.route.response.route[0].leg[stopIdx]
      if (!leg) {
        return
      }
      const stop = this.stops[stopIdx]
      const nextStop = this.stops[stopIdx + 1]
      let days = 0;
      let nights = 0;
      if (nextStop && nextStop.date) {
        const msToDay = 1000 * 3600 * 24
        const d1 = new Date(this.dateById(stop.date))
        const d2 = new Date(this.dateById(nextStop.date))
        const timedelta = d2 - d1
        nights = Math.ceil(timedelta/msToDay)
        days = nights - 1 > 0 ? nights - 1 : 0
        if (nights > 0) {
          this.overnightTrip = true
        }
      }
      const { travelTime, length } = leg
      const travelTimeHrs = travelTime/3600
      const miles = length/1609
      const extraDriver = travelTimeHrs >= 10
      let deadMiles
      if (stopIdx === 0) {
        deadMiles = this.deadHeads[0]
      } else if (stopIdx === this.stops.length - 2) {
        deadMiles = this.deadHeads[1]
      } else {
        deadMiles = 0
      }
      let querystring = '?miles='+miles+'&travelTime='+travelTimeHrs
      querystring = querystring + '&nights='+nights+'&days='+days
      querystring = querystring + '&extraDriver='+extraDriver
      querystring = querystring + '&deadMiles='+deadMiles
      const url = process.env.VUE_APP_VEHICLES_API + path + querystring
      return await axios.get(url, { headers })
    },
    async submit () {
      this.loading = true
      try {
        for (var i=0; i<this.stops.length - 1; i++) {
          let payload = this.stops[i]
          payload.rate_schemas = this.rates.map(busRate => busRate[i].id)
          await this.updateStop(payload)
        }
        return await this.postQuote()
      } catch (e) {
        this.raiseError(e)
        this.loading = false
        return
      }
    },
    friendlyLocation (val) {
      return val.split(',')[0]
    },
    postQuote () {
      const subTotal = this.pricing.reduce((acc, el) => {
        return acc + el.reduce((acc, el) => acc + el, 0)
      }, 0)
      const flatTotal = this.flatRates.reduce((acc, el) => {
        return acc + Math.max(...el)
      }, 0)
      const price = subTotal + flatTotal
      const route = this.route.response.route[0]
      const legs = route.leg
      const extraDriver = !!legs.some(leg => leg.travelTime/3600 > 10)
      const summary = route.summary
      const totalMiles = Math.ceil(summary.distance/1609)
      const deadMiles = Math.ceil(this.deadHeads[0] + this.deadHeads[1])
      const payload = {
        trip: this.trip,
        cost: price,
        ignore_cost: true,
        live_miles: totalMiles,
        dead_head_miles: deadMiles,
        extra_driver: extraDriver,
        overnight: this.overnightTrip
      }
      if (this.trip.dispatch === this.dispatchId) {
        payload.assigned_to = this.userId
      }
      return this.createQuote(payload).then(() => {
        setTimeout(() => {
          this.loading = false
        }, 5000)
        return this.$emit('continue')
      })
    },
    confirmSelectedRate (busIdx, stopIdx) {
      const bus = this.tripBuses[busIdx]
      const rate = this.ratesByBusTypeMap[bus.id].find(rs => rs.id === this.selectedRate)
      this.rates[busIdx].splice(stopIdx, 1, rate)
      this.selectedRate = null
      this.loading = true
      return this.getPriceAndTripFlat(busIdx, stopIdx).then(() => {
        this.loading = false;
      }).catch(e => {
        this.raiseError(e)
        this.loading = false
      })
    },
    getDefaultRate (busType) {
      return this.ratesByBusTypeMap[busType.id].find(r => r.rule.type === 'standard')
    },
    async getPriceAndTripFlat (busIndex, stopIndex) {
      const rate = this.rates[busIndex][stopIndex]
      const { data } = await this.getPrice(rate, stopIndex)
      const { price, tripFlat } = data
      this.pricing[busIndex].splice(stopIndex, 1, Math.ceil(price))
      this.flatRates[busIndex].splice(stopIndex, 1, tripFlat)
    },
    ...mapActions('plan', [ 'updateStop', 'createQuote' ]),
    ...mapActions('app', [ 'raiseError' ])
  },
}
</script>

<style lang="css" scoped>
</style>
